import React from 'react'
import {
    Card,
    CardContent,
    Divider,
    TextField,
    Typography,
    Accordion,
    AccordionSummary, AccordionDetails,
    Grid,
} from '@material-ui/core';
import { useStyles } from '../styles';
import { FiMinusCircle, FiPlusCircle } from 'react-icons/fi'
import Form from './Form';
import { useHistory } from "react-router-dom";
import BusinessServices from "../BusinessAccountsServices/services"
export default function AddAccount() {
    const classes = useStyles();
    const history = useHistory();
    const [submitted, setSubmitted] = React.useState(false);
    const [updatedData, setUpdatedData] = React.useState<any>({});
    const [open, setOpen] = React.useState(true);
    const handleOpen = () => {
        setOpen(!open)
    }
    
    return (
        <div>
            <Card className={classes.card}>
                <Accordion expanded={open}
                    onChange={handleOpen} style={{ padding: "5px" }}>
                    <AccordionSummary
                        expandIcon={open ? <FiMinusCircle color="#2645ad" /> : <FiPlusCircle color="#2645ad" />}
                        aria-controls="panel1a-content"
                        id="panel1a-header"
                    >
                        <Typography className={classes.heading}>
                            Business Account-Add New
                        </Typography>
                    </AccordionSummary>
                    <Divider className={classes.divider} />
                    <AccordionDetails className={classes.accordianNoFlex}>
                        <Form />
                    </AccordionDetails>
                </Accordion>
            </Card>
        </div>
    )
}
